import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { authorizationText, FooterMenu, footerMenuConfig, ipensiiDetailText } from './footer.config';
import { RouterLink } from '@angular/router';
import { EnvironmentService } from '@irian-ro/util-environment';
import { IpEnvironment } from '@ipensii/shared/domain-shared';

@Component({
  selector: 'ip-layout-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: 'footer.component.html',
  styleUrl: 'footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  readonly footerMenuItems: Array<FooterMenu>;
  readonly authorizationText: string = authorizationText;
  readonly ipensiiDetailText: string = ipensiiDetailText;

  constructor(env: EnvironmentService<IpEnvironment>) {
    this.footerMenuItems = footerMenuConfig(env.getEnvironment().presentationUrl);
  }
}
